import { registerLiteCustomElement } from 'maverick.js/element';
import { O as Outlet } from './media-core.js';
import { P as Player } from './player.js';
import { g as getUIComponents, C as CommunitySkin } from './media-community-skin.js';
import 'maverick.js';
import 'maverick.js/std';
import './providers/type-check.js';
import './providers/audio/loader.js';
import 'maverick.js/dom';
import './providers/hls/loader.js';
import './providers/video/loader.js';
import './media-ui.js';
import './icons/icon.js';
import 'media-captions';

function registerAllElements() {
  [Player, Outlet, ...getUIComponents(), CommunitySkin].map(registerLiteCustomElement);
}

export { registerAllElements as default };
